// @flow

import topic from 'app/developer-v3/components/PartnerSupportForm/components/blocks/Topic';
import developerPlatform from './developerPlatform';
import solutionPartner from './solutionPartner';

const loggedIn = topic({
  zendeskCustomFieldId: 38147919558029,
  label: 'How can we help you?',
  items: [
    {
      value: 'developer-platform',
      icon: 'miscBolt',
      label: 'Zapier Developer Platform & Integration Partner Program',
      child: developerPlatform,
      zendeskCustomFieldValue: 'pcf-developer-platform',
    },
    {
      value: 'solution-partner',
      icon: 'personCircleFill',
      label: 'Zapier Solution Partner Program',
      child: solutionPartner,
      zendeskCustomFieldValue: 'pcf-solution-partner',
    },
  ],
});

export default loggedIn;
